import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------ English ------------------------------ */
i18next.addResources(locales.EN, 'RESERVATIONS_FORM', {
  TITLE: 'Reservation Form',
  PERSON: 'Applicant',
  FAMILY: 'Family',
  CHILDREN: 'Children',
  LOCATION: 'Location',
  MANAGER: 'Manager',
  PAYMENT: 'Payment',
  COMMENTS: 'Comments',
  PERSON_INFORMATION: 'Applicant information',
  FAMILY_INFORMATION: 'Family information',
  CHILDREN_INFORMATION: 'Children information',
  LOCATION_INFORMATION: 'Location information',
  MANAGER_INFORMATION: 'Manager information',
  PAYMENT_INFORMATION: 'Payment information',
  NAME: 'First name',
  LAST_NAME: 'Last name',
  ID_CARD_TYPE: 'ID Card type',
  ID_CARD: 'ID Card',
  ID_CARD_FILE: 'ID Card File (scanned)',
  ID_CARD_BACK_FILE: 'ID Card Back File (scanned)',
  ADDRESS: 'Address',
  AGE: 'Age',
  AREA_CODE: 'Area code',
  PHONE: 'Phone',
  COMMUNITY: 'Community',
  CIVIL_STATE: 'Civil state',
  WEDDING_TEMPLE: 'Wedding temple',
  KETUBA_FILE: 'Ketubá',
  MARRIAGE_CERTIFICATE_FILE: 'Marriage certificate',
  GET_FILE: 'GET',
  SPOUSE_INFO: 'Spouse information (indicate if they live or not)',
  FATHER_INFO: 'Father information (indicate if they live or not, and cemetery if applicable)',
  MOTHER_INFO: 'Mother information (indicate if they live or not, and cemetery if applicable)',
  CHILDREN_INFO: 'Names, last names, civil state and with whom they are married',
  CEMENTERY: 'Cemetery',
  PLOT: 'Plot',
  RELATIONSHIP: 'Relationship with the manager',
  CURRENCY: 'Currency',
  AMOUNT: 'Amount',
  PAYMENT_METHOD: 'Payment method',
  SUBMIT_BUTTON: 'Submit',
  LOADING: 'Loading...',
  BLOCK: 'Block',
  GRAVE: 'Grave',
  ROW: 'Row',
  PLANK: 'Plank',
  SECTOR: 'Sector',
  ID_MANAGER_DESC: 'ID card front and back of the person responsible for the reservation.',
  KETUBA_RESERVATION_DESC: 'Religious documentation to validate family links.',
  MARRIAGE_RESERVATION_DESC: 'Civil marriage certificate to register beneficiaries.',
});

/* ------------------------------ Spanish ------------------------------ */
i18next.addResources(locales.ES, 'RESERVATIONS_FORM', {
  TITLE: 'Formulario de Reserva',
  PERSON: 'Solicitante',
  FAMILY: 'Familiares',
  CHILDREN: 'Hijos',
  LOCATION: 'Ubicación',
  MANAGER: 'Destinatario',
  PAYMENT: 'Pago',
  COMMENTS: 'Observaciones',
  PERSON_INFORMATION: 'Información del solicitante',
  FAMILY_INFORMATION: 'Información de los familiares',
  CHILDREN_INFORMATION: 'Información de los hijos',
  LOCATION_INFORMATION: 'Ubicación de la reserva',
  MANAGER_INFORMATION: 'Información del destinatario',
  PAYMENT_INFORMATION: 'Información de pago',
  NAME: 'Nombre',
  LAST_NAME: 'Apellido',
  ID_CARD_TYPE: 'Tipo de documento',
  ID_CARD: 'Documento',
  ID_CARD_FILE: 'Documento de identidad (escaneado)',
  ID_CARD_BACK_FILE: 'Documento dorso (escaneado)',
  ADDRESS: 'Domicilio',
  AGE: 'Edad',
  AREA_CODE: 'Código de área',
  PHONE: 'Celular',
  COMMUNITY: 'Comunidad',
  CIVIL_STATE: 'Estado civil',
  WEDDING_TEMPLE: 'Templo donde se casó',
  KETUBA_FILE: 'Ketubá',
  MARRIAGE_CERTIFICATE_FILE: 'Libreta de casamiento',
  GET_FILE: 'GET',
  SPOUSE_INFO: 'Nombre y apellido del cónyuge (indicar si vive o no)',
  FATHER_INFO: 'Nombre y apellido del padre (indicar si vive o no, y cementerio si corresponde)',
  MOTHER_INFO: 'Nombre y apellido de la madre (indicar si vive o no, y cementerio si corresponde)',
  CHILDREN_INFO: 'Nombres, apellidos, estado civil y con quién están casados',
  CEMENTERY: 'Cementerio',
  PLOT: 'Parcela',
  RELATIONSHIP: 'Relación con el destinatario',
  CURRENCY: 'Moneda',
  AMOUNT: 'Importe',
  PAYMENT_METHOD: 'Forma de pago',
  SUBMIT_BUTTON: 'Enviar',
  LOADING: 'Cargando...',
  BLOCK: 'Manzana',
  GRAVE: 'Tumba',
  ROW: 'Fila',
  PLANK: 'Tabla',
  SECTOR: 'Sector',
  ID_MANAGER_DESC: 'DNI Frente y Dorso del titular responsable de la reserva.',
  KETUBA_RESERVATION_DESC: 'Documentación religiosa para acreditar vínculo familiar.',
  MARRIAGE_RESERVATION_DESC: 'Acta de matrimonio civil para el registro de beneficiarios.',
});
